import { useDispatch, useSelector } from 'react-redux';

import usingStorage from 'app/utils/storage';
import { setMenuOpenedAction, setCurrentPathnameAction, setBackPathnameAction, getMenu, setCurrentDashboardAction } from 'features/menu/redux/slice';

import { UseMenuState } from './types';
import { useCallback } from 'react';

const storage = usingStorage('localStorage');

const useMenu = (): UseMenuState => {
  const { isOpened, currentPathname, backPathname, currentDashboard } = useSelector(getMenu);
  const dispatch = useDispatch();

  const setMenuOpened = (isOpened: boolean) => {
    dispatch(setMenuOpenedAction(isOpened));
  };

  const setCurrentPathname = (pathname: string | null) => {
    dispatch(setCurrentPathnameAction(pathname));
  };

  const setBackPathname = (pathname: string) => {
    dispatch(setBackPathnameAction(pathname));
  };

  const clearBackPathname = () => {
    dispatch(setBackPathnameAction(``));
  };

  const toggleMenuOpened = useCallback(() => {
    setMenuOpened(!isOpened);
  }, [isOpened]);

  const setCurrentDashboard = (currentDashboard: string | null) => {
    if (currentDashboard) {
      storage.set('currentDashboard', currentDashboard);
    } else {
      storage.remove('currentDashboard');
    }

    dispatch(setCurrentDashboardAction(currentDashboard));
  };

  return {
    isOpened,
    setMenuOpened,
    toggleMenuOpened,
    currentPathname,
    setCurrentPathname,
    backPathname,
    setBackPathname,
    clearBackPathname,
    currentDashboard,
    setCurrentDashboard,
  };
};

export default useMenu;
